import React, { useEffect, useState } from "react";
import "./Prescriptions.css";
import Blue_Round_Btn from "../../../common-components/common-btn/blue_round_btn/Blue_Round_Btn";
import View_Prescription_Modal from "../../../common-components/common-modals/view_prescription_modal/View_Prescription_Modal";
import Lense_prescription_modal from "../../../common-components/common-modals/want-buy-modal/Lense_prescription_modal";
import { getAllLensOption } from "../../../../features/master/masterSlice";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "react-router-dom";
import { getAllPrescription } from "../../../../features/prescription/prescriptionSlice";
import { formatDate } from "../../../../utils/common";
import Lense_prescription_modal_show from "../../../common-components/common-modals/want-buy-modal/Lense_prescription_modal_show";
import { AiOutlineFileText } from "react-icons/ai";
const Prescriptions = ({ product, variant, product_id, ...props }) => {
  const imageList = [1, 2, 3];

  const [lensemodal, setLensemodal] = useState(false);
  const [lensName, setLensName] = useState("Single Vision (only distance)");

  const [lensId, setLensId] = useState(1);

  const [lensOptionId, setLensOptionId] = useState();
  const dispatch = useDispatch();
  const lensOptions = useSelector((state) => state.master.lens_option);
  const handleOnClick = async (id, name) => {
    // props.onHide();
    // setLensemodal(true);
    setLensId(id);
    setLensName(name);
    await dispatch(getAllLensOption(id));
  };

  useEffect(() => {
    dispatch(getAllLensOption(lensId));
  }, []);

  const handleChange = (e) => {
    setLensOptionId(e.target.value); // store selected ID
  };

  const allPrescription = useSelector(
    (state) => state.prescription.allPrescription
  );
  useEffect(() => {
    dispatch(getAllPrescription());
  }, [dispatch]);
  const [Id, setId] = useState("");
  const handelclick = async (id) => {
    await setId(id);
    setLensemodal(true);
  };

  const handelclickPDF = (url) => {
    if (!url) return;

    const fileExt = url
      .split(".")
      .pop()
      .toLowerCase();

    // Check PDF
    if (fileExt === "pdf") {
      window.open(url, "_blank"); // opens PDF in new tab
      return;
    }

    // Check Image
    const imageExt = ["jpg", "jpeg", "png", "webp"];
    if (imageExt.includes(fileExt)) {
      window.open(url, "_blank"); // opens image in new tab
      return;
    }

    // Optional: handle unknown formats
    alert("Unsupported file type");
  };

  return (
    <section className="Prescriptions">
      <div className="row">
        {allPrescription?.length > 0 ? (
          allPrescription.map((item, index) => (
            <div
              className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 mb-3"
              key={index}
            >
              <div className="prescription_card">
                <div className="outer_gray_box">
                  <div className="info_holder">
                    {/* <div className="text_holder">
                    <h4>Name</h4>
                    <p>Smita Madan Lad</p>
                  </div> */}
                    <div className="text_holder">
                      <div className="row">
                        <div className="col-lg-4">
                          <h4>Date</h4>
                        </div>
                        <div className="col-lg-8">
                          <p>{formatDate(item?.createdAt)}</p>
                        </div>
                      </div>
                    </div>

                    <div className="text_holder">
                      <div className="row">
                        <div className="col-lg-4">
                          <h4>Lens Type</h4>
                        </div>
                        <div className="col-lg-8">
                          <p>{item?.LensType?.name || "NA"}</p>
                        </div>
                      </div>
                    </div>
                    <div className="text_holder">
                      <div className="row">
                        <div className="col-lg-4">
                          <h4>Lense</h4>
                        </div>
                        <div className="col-lg-8">
                          <p>{item?.Lense?.name || "NA"}</p>
                        </div>
                      </div>
                    </div>

                    <div className="text_holder">
                      <div className="row">
                        <div className="col-lg-4">
                          <h4>Addon</h4>
                        </div>
                        <div className="col-lg-8">
                          <p>{item?.Addon?.name || "NA"}</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="close_img_holder">
                    <img
                      src="/assets/images/my_account/prescription/close.png"
                      className="delete_img"
                    />
                  </div>
                </div>
                {item.pdf ? (
                  <div className="view_btn">
                    <Blue_Round_Btn
                      btnText={"View"}
                      onClick={() => {
                        handelclickPDF(
                          process.env.REACT_APP_IMAGE_URL + item?.pdf
                        );
                      }}
                    />
                  </div>
                ) : (
                  <div className="view_btn">
                    <Blue_Round_Btn
                      btnText={"View"}
                      onClick={() => {
                        handelclick(item?.id);
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
          ))
        ) : (
          <div className="empty-state text-center my-5">
            <AiOutlineFileText
              size={80}
              color="#888"
              style={{ marginBottom: "20px" }}
            />
            <h5>No prescriptions available</h5>
            <p>Your uploaded prescriptions will appear here.</p>
          </div>
        )}
      </div>

      <Lense_prescription_modal_show
        id={Id}
        product={product}
        variant={variant}
        product_id={product_id}
        lensId={lensId}
        lensOptionId={lensOptionId}
        show={lensemodal}
        onHide={() => setLensemodal(false)}
      />
    </section>
  );
};

export default Prescriptions;
